import { Tag } from "antd";
import React from "react";

export interface CustomTagProps {
  label?: string;
  icon: React.ReactNode;
  color: "green" | "red" | "orange";
  height?: number;
}

const CustomTag: React.FC<CustomTagProps> = ({
  label,
  icon,
  color,
  height = 25,
}) => {
  const styles = {
    tagStyle: {
      height: `${height}px`,
      fontSize: "13px",
      border: "2px solid",
      borderRadius: "999px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "4px", // more spacing between icon and text
    },
  };

  const textStyle = {
    color: color,
    fontSize: "11px",
    fontWeight: "bold" as const,
  };

  return (
    <Tag icon={icon} color={color} style={styles.tagStyle}>
      {label && <span style={textStyle}>{label}</span>}
    </Tag>
  );
};

export default CustomTag;
